import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-soonlabs',
  templateUrl: './soonlabs.component.html',
  styleUrls: ['./soonlabs.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoonlabsIconComponent {}
